module.exports = __webpack_public_path__ + "static/media/metro3-6.ac78f581.jpg";